import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Student {
  studentId: string;
  classWorkMark: number | null;
  homeworkMark: number | null;
  state?: string | null;
  comment: string | null;
}

export interface StudentState {
  students: Student[];
  lessonId: string;
}

const initialState: StudentState = {
  students: [],
  lessonId: "",
};

const studentSlice = createSlice({
  name: 'students',
  initialState,
  reducers: {
    updateStudentMarks: (
      state,
      action: PayloadAction<{
        studentId: string;
        classWorkMark?: number | null;
        homeworkMark?: number | null;
        state?: string;
        comment?: string | null;
      }>
    ) => {
      const { studentId, classWorkMark, homeworkMark, state: newState, comment } = action.payload;
      const student = state.students.find((s) => s.studentId === studentId);

      if (student) {
        if (classWorkMark !== undefined) {
          student.classWorkMark = classWorkMark;
        }
        if (homeworkMark !== undefined) {
          student.homeworkMark = homeworkMark;
        }
        if (newState !== undefined) {
          student.state = newState;
        }
        if (comment !== undefined) {
          student.comment = comment;
        }
      }
    },

    addStudent: (
      state,
      action: PayloadAction<{
        studentId: string;
        classWorkMark?: number | null;
        homeworkMark?: number | null;
        state?: string | null;
        comment?: string | null;
      }>
    ) => {
      const { studentId, classWorkMark, homeworkMark, state: newState, comment } = action.payload;

      const existingStudent = state.students.find((student) => student.studentId === studentId);

      if (existingStudent) {
        if (classWorkMark !== undefined) {
          existingStudent.classWorkMark = classWorkMark;
        }
        if (homeworkMark !== undefined) {
          existingStudent.homeworkMark = homeworkMark;
        }
        if (newState !== undefined) {
          existingStudent.state = newState;
        }
        if (comment !== undefined) {
          existingStudent.comment = comment;
        }
      } else {
        state.students.push({
          studentId,
          classWorkMark: classWorkMark !== undefined ? classWorkMark : null,
          homeworkMark: homeworkMark !== undefined ? homeworkMark : null,
          state: newState !== undefined ? newState : null,
          comment: comment !== undefined ? comment : null,
        });

      }
    },

    setLessonId: (state, action: PayloadAction<string>) => {
      state.lessonId = action.payload;
    },

    resetStudents: (state) => {
      state.students = [];
      state.lessonId = "";
    },

    removeStudent: (state, action: PayloadAction<{ studentId: string }>) => {
      state.students = state.students.filter(
        (student) => student.studentId !== action.payload.studentId
      );
    },
  },
});

export const { updateStudentMarks, addStudent, setLessonId, resetStudents, removeStudent } = studentSlice.actions;
export default studentSlice.reducer;